<div [class]="data.error ? 'container error' : ' container'">
 
  <div class= "closeButtonContainer">
        <ds-icon *ngIf="!data.error"
          class="iconSuccess"
          color="info5"
          size="36"
          icon-name="bi-check-circle-fill"
      ></ds-icon>
      <ds-icon *ngIf="data.error"
          class="iconSuccess"
          color="info4"
          size="36"
          icon-name="bi-x-circle"
      ></ds-icon>
    </div>
    <br>

  <div
    [class]="data.error ? 'textContainer error' : 'textContainer success'"
    style="margin-top: -25px"
  >
    <p class="title" style="margin-bottom: 0px; font-size: 16px;">{{ data.title }}</p>
    <p class="subtitle" style="margin-top: 0px; font-size: 14px">{{ data.message }}</p>
  </div>

  <div class="buttons-error-rescates">
      <ds-button (click)="close()" class="float-end"  variant="primary">
        <span slot="text2">Aceptar</span>
      </ds-button>
  </div>
</div>
